export interface FastFormData {
  receiverIBAN: string;
  receiverIdNo: string;
  receiverNameSurname: string;
  paymentPurpose: string;
  value: string;
  description: string;
  currency: string;
}

export interface Commission {
  valueFee: number;
  total: number;
}

export interface UserInfo {
  companyId: number;
  customerId: number;
  selectedUserInfo: number;
  // Add other user properties as needed
}

export interface PaymentPurposeOption {
  value: string;
  label: string;
}

export interface FastTransferRequest {
  currencyId: number;
  value: number;
  description: string | null;
  valueFee: number;
  receiverIBAN: string;
  receiverNameSurname: string;
  receiverIdNo: string;
  paymentPurpose: string;
  companyId: number;
  customerId: number;
}

export const PAYMENT_PURPOSE_OPTIONS: PaymentPurposeOption[] = [
  { value: '', label: 'Seçiniz' },
  { value: '05', label: 'Çalışan Ödemesi' },
  { value: '06', label: 'Ticari ödeme' },
  { value: '04', label: 'E-Ticaret Ödemesi' },
  { value: '09', label: 'Finansal' },
  { value: '08', label: 'Yatırım' },
  { value: '02', label: 'İş yeri Kirası Ödemesi' },
  { value: '03', label: 'Diğer Kira Ödemesi' },
  { value: '01', label: 'Konut Kirası Ödemesi' },
  { value: '07', label: 'Bireysel Ödeme' },
  { value: '11', label: 'Aidat ödemesi' },
  { value: '10', label: 'Eğitim ödemesi' },
];
